interface ProgressIndicatorProps {
  progress: number;
  required: number;
  loopCount: number;
}

export function ProgressIndicator({ progress, required, loopCount }: ProgressIndicatorProps) {
  return (
    <div className="progress-panel" aria-label={`進行度 ${progress}/${required}、巻き戻り ${loopCount}回`}>
      <div className="progress-header">
        <span>監視継続記録</span>
        <span>{progress}/{required}</span>
      </div>
      <div className="progress-dots" aria-hidden="true">
        {Array.from({ length: required }, (_, index) => (
          <span key={index} className={index < progress ? "progress-dot is-filled" : "progress-dot"} />
        ))}
      </div>
      <div className="progress-sub">巻き戻り記録: {loopCount}</div>
    </div>
  );
}
